import {
    SidebarQueueProps,
    SidebarQueuesProps,
} from './types'
import {
    useAppDispatch,
    useAppSelector,
} from '../../hooks'
import {NinchatProperties} from '../../api/types'
import React from 'react'
import SidebarQueuesView from './SidebarQueuesView'
import {acceptAudience} from '../../api/action/acceptAudience'
import {confirmationModal} from '../../actions/modal'
import {getRealmQueues} from '../../selectors/ninchat'
import {navigation} from '../../navigation'
import {toast} from '../Toast'
import {useTranslation} from 'react-i18next'

const SidebarQueues = ({realm_id}: SidebarQueuesProps): React.ReactElement => {
    const dispatch = useAppDispatch()

    const {t} = useTranslation()

    const loadQueue = (queue_id?: NinchatProperties.QueueID): void => {
        if (queue_id) {
            navigation.push('Queue', {queue_id})
        }
    }

    const loadQueueSettings = (queue_id?: NinchatProperties.QueueID): void => {
        if (queue_id) {
            navigation.push('QueueSettings', {queue_id})
        }
    }

    const loadQueueStatistics = (queue_id?: NinchatProperties.QueueID): void => {
        if (queue_id) {
            navigation.push('QueueStatistics', {
                queue_id,
                tab: 'default',
            })
        }
    }

    const queues = useAppSelector(({ninchat}): Array<NinchatProperties.QueueID> => {
        const queueList = realm_id ? getRealmQueues(ninchat, realm_id) : []
        return queueList.map((item: SidebarQueueProps):NinchatProperties.QueueID => item.queue_id)
    })

    const sidebar_classic_audience_grouping = useAppSelector(({ninchat}) => ninchat.user_settings.sidebar_classic_audience_grouping ?? false)

    const onAcceptAudience = (queueId?: NinchatProperties.QueueID): void => {
        if (queueId) {
            dispatch(acceptAudience({queue_id: queueId}))
                .unwrap()
                .then(() => {
                    toast.success(t('Audience accepted'))
                }, () => {
                    toast.error(t('Error accepting audience'))
                })
        }
    }

    const toggleQueueConfirmationModal = (queueId: NinchatProperties.QueueID | undefined, close: boolean) => {
        dispatch(confirmationModal({
            onConfirm: {
                action: close ? 'closeQueue' : 'openQueue',
                queueId,
            },
            show: true,
            text: close ? t('Visitors already queueing stay in queue. New visitors won\'t be able to join the queue.') : t('Are you sure you wish to open this queue?'),
            title: close ? t('Close queue?') : t('Open queue?'),
        }))
    }

    const onToggleQueue = (queueId: NinchatProperties.QueueID | undefined, closed: boolean): void => {
        if (queueId) {
            toggleQueueConfirmationModal(queueId, !closed)
        }
    }

    return queues?.length > 0
        ? (
            <SidebarQueuesView
                loadQueue={loadQueue}
                loadQueueSettings={loadQueueSettings}
                loadQueueStatistics={loadQueueStatistics}
                nestedSidebar={!sidebar_classic_audience_grouping}
                onAcceptAudience={onAcceptAudience}
                onToggleQueue={onToggleQueue}
                queues={queues}
            />
        )
        : <> </>
}

export default SidebarQueues
